// extracted by mini-css-extract-plugin
module.exports = {"friendsBox":"style_friendsBox__3YbBG","friendsList":"style_friendsList__1xMns"};